// **********************************************************
//  News-list-slider
// **********************************************************
/* eslint-disable */
$(function () {

  //  newsListSlider slider
  new Swiper('.news-list-slider', {
    slidesPerView: 'auto',
    spaceBetween: 25,
    freeMode: true,
    navigation: {
      nextEl: '.news-list-slider__nav-arrow.next',
      prevEl: '.news-list-slider__nav-arrow.prev',
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1023: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 36,
      },
    },
  });
});
/* eslint-enable */
